import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "position-absolute bottom-0 w-100 p-2",
  style: {"z-index":"2"}
}
const _hoisted_2 = { class: "d-flex flex-column mt-auto small" }
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = { class: "fw-semibold" }
const _hoisted_5 = { class: "fw-semibold" }

import { PropType } from 'vue';
import BadgeDefault from '@/atomic/atoms/BadgeDefault.vue';
import Recipe from '@/typings/classes/recipe.class';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipeBadgeDetailsOrganism',
  props: {
  recipe: { type: Object as PropType<Recipe>, required: true },
},
  setup(__props) {

const props = __props;
function formatNumber(number: number | undefined): string {
  return (number ?? 0).toFixed(0).toString().padStart(2, '\u00A0');
}
const energy = formatNumber(props.recipe.calories);
const cookingTime = formatNumber(props.recipe.cookingTime);
const preparationTime = formatNumber(props.recipe.preparationTime);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BadgeDefault, { class: "bg-white text-primary" }, {
          default: _withCtx(() => [
            _createTextVNode(" ⏱ "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(Number(_unref(preparationTime)) + Number(_unref(cookingTime))), 1),
            _createTextVNode(" min ")
          ]),
          _: 1
        }),
        _createVNode(BadgeDefault, { class: "ms-auto bg-white text-primary" }, {
          default: _withCtx(() => [
            _createTextVNode(" 🔥 "),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(energy)), 1),
            _createTextVNode(" kcal ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})